
import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Region } from "@/types/region";

interface RegionSelectorProps {
  selectedRegion: string;
  regions: Region[] | undefined;
  onRegionChange: (value: string) => void;
}

export const RegionSelector = ({ 
  selectedRegion, 
  regions, 
  onRegionChange 
}: RegionSelectorProps) => {
  return (
    <Select 
      value={selectedRegion} 
      onValueChange={onRegionChange}
    >
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Select region" />
      </SelectTrigger>
      <SelectContent>
        {regions?.filter(region => region.active).map((region) => (
          <SelectItem key={region.code} value={region.code} className="capitalize">
            {region.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
